import hasCapitalizedFields from './utilities/hasCapitalizedFields';

const form = (formJson) => {
  const properties = {
    ...formJson.attributes,
    guid: formJson.guid,
    type: formJson.type,
  };
  return Object.assign(
    properties,
    hasCapitalizedFields(formJson.attributes),
  );
};

export default form;
